<template>
  <dashboard-section v-if="assessments.length">
    <template #title>
      <h2 class="text-xl border-r pr-6 mr-6">
        My Assessments
      </h2>
      <icon-link
        class="font-normal"
        :href="route('assessments.index')"
        icon="cheveron-right-circle"
        icon-placement="right"
      >
        All assessments
      </icon-link>
    </template>
    <ul class="list-reset flex flex-wrap -mx-4">
      <li
        v-for="assessment in assessments"
        :key="assessment.uuid"
        class="w-full lg:w-1/3 lg:flex p-4"
      >
        <user-assessment-card
          :application="assessment"
          :applicants="applicants"
        />
      </li>
      <li
        v-for="filler in [1, 2, 3].slice(assessments.length, 3)"
        :key="filler"
        class="hidden lg:w-1/3 lg:flex p-4"
        style="min-height: 13rem"
      >
        <div class="w-full border-dashed border border-grey-300" />
      </li>
    </ul>
  </dashboard-section>
</template>

<script>
export default {
  name: "DashboardAssessments",
  props: {
    assessments: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    applicants() {
      return this.assessments.reduce((obj, assessment) => {
        const a = assessment.application;
        obj[assessment.uuid] = {
          name: a.lead_applicant.name,
          email: a.lead_applicant.email,
          company: a.lead_applicant.company.company_details.name
        };
        return obj;
      }, {});
    }
  }
};
</script>
